import type { ReactNode } from 'react';

import cn from '@/lib/utils/cn';

import CopyButton from './CopyButton';

type Props = {
  items: {
    label: string;
    value: ReactNode;
    copy?: boolean;
  }[];
  columns?: number;
};

export default function PropertiesList({ items, columns }: Props) {
  const cols = columns ?? 2;

  return (
    <div
      className={cn('grid gap-3', {
        ['grid-cols-1']: cols === 1,
        ['grid-cols-2']: cols === 2,
        ['grid-cols-3']: cols === 3,
        ['grid-cols-4']: cols === 4,
      })}
    >
      {items.map((item) => (
        <div key={item.label} className="flex flex-col">
          <span className="text-muted-foreground text-[10px] uppercase">
            {item.label}
          </span>

          <div className="flex items-center gap-0.5">
            <span className="text-sm leading-tight">{item.value ?? '-'}</span>

            {item.copy &&
              (typeof item.value === 'string' ||
                typeof item.value === 'number') && (
                <CopyButton text={item.value.toString()} />
              )}
          </div>
        </div>
      ))}
    </div>
  );
}
